import React, { useState } from 'react';
import { Box, Button, TextField, Typography } from '@mui/material';
import { styled } from '@mui/system';
import backgroundImage from '../assets/images/login-background.png';
import unilabLogo from '../assets/images/Unilab-logo.png';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { useSnackbar } from 'notistack';
import { loginRequest } from '../config';
import AuthService from '../services/auth';

const LeftContainer = styled(Box)({
    flex: '0 0 40%',
    backgroundColor: '#00bfff',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '2rem',
    color: 'white',
});

const RightContainer = styled(Box)({
    flex: 1,
    backgroundImage: `url(${backgroundImage})`, 
    backgroundSize: 'cover',
    backgroundPosition: 'center',
});

const LoginScreen = () => {

    const { instance } = useMsal();

    const enqueueSnackbar = useSnackbar();

    const [isProcessing, setIsProcessing] = useState(false);  

    let isMounted = true;

    const login = async () => {
        if (isProcessing) return; // Prevent multiple clicks

        setIsProcessing(true);  // Set processing to true

        try {
            await instance.initialize(); // Ensure instance is initialized
            const res = await instance.loginPopup(loginRequest);
            if (res && isMounted) {
               window.location.href = "/dashboard"
            }
        } catch (error) {
            alert("Login failed. Please try again.")
        } finally {
            if (isMounted) {
                setIsProcessing(false);  // Reset processing after login attempt
            }
        }
    };

    return (
        <Box display="flex" height="100vh">
            <LeftContainer>
                <img alt="unilab-logo" src={unilabLogo} style={{ width: '60%' }} />
                <Box sx={{ mt: 10 }} />

                <Typography  gutterBottom  sx={{ fontSize: 30, fontFamily: 'Poppins, sans-serif' }}>
                    OVI Guard Enterprise Portal
                </Typography>
                <Box sx={{ mt: 3 }} />
                <Button variant="contained" 
                    sx={{ fontSize: 20, background: '#0c306f', color: '#fff', textTransform: 'none', width: '50%', fontFamily: 'Poppins, sans-serif' }} 
                    disabled={isProcessing} 
                    onClick={login}
                >
                    {isProcessing ? 'Processing' : 'Login' }
                </Button>
            </LeftContainer>
            <RightContainer />
        </Box>
    );
};

export default LoginScreen;
